// src/components/FilterBar/FilterBar.js
import React from 'react';

const BRAZILIAN_STATES = [
  ['AC', 'Acre'], ['AL', 'Alagoas'], ['AP', 'Amapá'], ['AM', 'Amazonas'],
  ['BA', 'Bahia'], ['CE', 'Ceará'], ['DF', 'Distrito Federal'], ['ES', 'Espírito Santo'],
  ['GO', 'Goiás'], ['MA', 'Maranhão'], ['MT', 'Mato Grosso'], ['MS', 'Mato Grosso do Sul'],
  ['MG', 'Minas Gerais'], ['PA', 'Pará'], ['PB', 'Paraíba'], ['PR', 'Paraná'],
  ['PE', 'Pernambuco'], ['PI', 'Piauí'], ['RJ', 'Rio de Janeiro'], ['RN', 'Rio Grande do Norte'],
  ['RS', 'Rio Grande do Sul'], ['RO', 'Rondônia'], ['RR', 'Roraima'], ['SC', 'Santa Catarina'],
  ['SP', 'São Paulo'], ['SE', 'Sergipe'], ['TO', 'Tocantins'],
];

const COUNTRIES = [
  { code: 'BR', label: 'Brasil' },
  { code: 'AR', label: 'Argentina' },
  { code: 'BO', label: 'Bolívia' },
  { code: 'CL', label: 'Chile' },
  { code: 'CO', label: 'Colômbia' },
  { code: 'PE', label: 'Peru' },
  { code: 'VE', label: 'Venezuela' },
  { code: 'OTHER', label: 'Outro' },
];

const FilterBar = ({
  selectedType,
  handleTypeChange,
  selectedCountry,
  handleCountryChange,
  selectedState,
  handleStateChange,
  selectedCity,
  handleCityChange,
  cityOptions = [],
  showFavoritesOnly = false,
  handleFavoritesToggle,
}) => {
  const isBrazil = !selectedCountry || selectedCountry === 'BR';

  return (
    <div className="filter-bar flex flex-wrap items-center justify-between py-4 px-0">
      <div className="flex flex-wrap gap-4 items-center">
        <div className="filter-item">
          <label htmlFor="type-filter">Tipo:</label>
          <select id="type-filter" value={selectedType} onChange={handleTypeChange} className="ml-2">
            <option value="">Todos</option>
            <option value="demand">Demanda</option>
            <option value="offer">Oferta</option>
          </select>
        </div>

        <div className="filter-item">
          <label htmlFor="country-filter">País:</label>
          <select
            id="country-filter"
            value={selectedCountry || ''}
            onChange={handleCountryChange}
            className="ml-2"
          >
            <option value="">Todos</option>
            {COUNTRIES.map(({ code, label }) => (
              <option key={code} value={code}>{label}</option>
            ))}
          </select>
        </div>

        <div className="filter-item">
          <label htmlFor="state-filter">Estado:</label>
          <select
            id="state-filter"
            value={selectedState || ''}
            onChange={handleStateChange}
            className="ml-2"
            disabled={!isBrazil}
          >
            <option value="">{isBrazil ? 'Todos' : '—'}</option>
            {isBrazil &&
              BRAZILIAN_STATES.map(([uf, name]) => (
                <option key={uf} value={uf}>{name}</option>
              ))}
          </select>
        </div>

        <div className="filter-item">
          <label htmlFor="city-filter">Cidade:</label>
          <select
            id="city-filter"
            value={selectedCity || ''}
            onChange={handleCityChange}
            className="ml-2"
            disabled={!selectedState || cityOptions.length === 0}
          >
            <option value="">Todas</option>
            {cityOptions.map((city) => (
              <option key={city} value={city}>{city}</option>
            ))}
          </select>
        </div>

        {handleFavoritesToggle && (
          <div className="filter-item">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={showFavoritesOnly}
                onChange={(e) => handleFavoritesToggle(e.target.checked)}
              />
              Somente favoritos
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterBar;
